import { LoadingOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Markdown } from '@wair/markdown'
import { Divider, Spin, Modal, message } from 'antd'

import userAvatar from '@/assets/images/chat-user.svg'
import cuAvatar from '@/assets/images/cu-avatar.png'
import { SessionStatuTypes, SseResponseEventEnum } from '@/constants/agent'
import { assistantState } from '@/store/assistant'
import React, { useEffect, useState } from 'react'
import { useSnapshot } from 'valtio'
import ImageLoading from './ImageLoading'
import ToolContent from './ToolContent'
import styles from './index.module.less'
// import UserContent from './UserContent'
// import AssistantContent from './AssistantContent'
import defaultAvatar from '@/assets/images/assistant/default-avatar.svg'
import { cn } from '@/utils/css'
import { Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { copyToClipboard } from '@/utils/copyToClipboard'
import { useAgentChat } from '@/hooks/useAgentChat'

const avatarMap = {
  Human: userAvatar,
  AI: cuAvatar,
}

export default function ChatItem({ item, isShare, isLast }: any) {
  const { sessionStatu, isLoadingQuestion } = useSnapshot(assistantState)
  const { isLoading } = useAgentChat()
  const [visible, setVisible] = useState(false)
  const [pageContents, setPageContents] = useState<any>([]) // 引用内容列表 eg:['xxx','xxxx']
  const [curRefIndex, setCurRefIndex] = useState<any>([]) // 角标列表eg:[1,3]
  const [curPage, setCurPage] = useState<number>(0) // 翻页页码，和角标无关，仅处理翻页
  const [docName, setDocName] = useState<string>('') // 当前引用文档标题
  const [isTextCopied, setIsTextCopied] = useState(false)

  const showGenerate = item.out_finished === true
  const handleDoc = (
    reference_index: any,
    page_contents: any,
    docName: any,
    curPage: any,
  ) => {
    setCurRefIndex(reference_index)
    setPageContents(page_contents)
    setDocName(docName)
    setCurPage(curPage)
    setVisible(true)
  }
  // 翻页页码，和角标无关，仅处理翻页
  const changeRefPage = (index: number, pageIndex?: string) => {
    if (curPage === 0 && index === -1) return
    if (curPage === pageContents.length - 1 && index === 1) return
    if (pageIndex) {
      setCurPage(Number(pageIndex))
      return
    }
    setCurPage(curPage + index)
  }
  const handleCancel = () => {
    setVisible(false)
  }
  const handleCopy = async (content: string) => {
    await copyToClipboard(content)
    if (isTextCopied) return
    assistantState.inputText = content
    setIsTextCopied(true)
    message.success('复制成功')
    setTimeout(() => {
      setIsTextCopied(false)
    }, 2000)
  }
  // useEffect(() => {}, [])
  if (item.newChat) {
    return (
      <Divider plain={true} className={styles.newChatDivider}>
        全新的开始
      </Divider>
    )
  }
  return (
    <div className={styles.chatItemWrap}>
      <div className={styles.chatItem}>
        {/* <div className={styles.chatAvatar}>
          {item.obj === 'AI' ? (
            <img src={curSelectAssistant.image || defaultAvatar} />
          ) : (
            <img src={avatarMap[item.obj as keyof typeof avatarMap]} />
          )}
        </div> */}

        <div className="flex-1 relative overflow-hidden">
          {item.obj === 'Human' && (
            <div
              className={cn(
                styles.userContent,
                'items-end group overflow-hidden',
              )}
            >
              <div className="max-w-[80%] rounded-xl px-5 py-3 text-content-first text-sm bg-[#1C1F2308] whitespace-pre-wrap break-all hover:cursor-pointer">
                <div>{item.value}</div>
              </div>
              <Button
                className={`items-center text-sm text-[#1C1F23] gap-1 invisible ${
                  !isShare && 'group-hover:visible'
                }`}
                variant="custom"
                size="xs"
                onClick={() => handleCopy(item.value)}
              >
                <Copy size={14} />
                复制入框
              </Button>
            </div>
          )}
          {item.obj === 'AI' && (
            <div className={styles.assistantContent}>
              <div className={''}>
                {item.loading && (
                  // <Spin
                  //   style={{ width: '20px' }}
                  //   indicator={<LoadingOutlined spin />}
                  // />
                  <img
                    className="w-5 h-5"
                    src="https://zdtc-cdn.wair.ac.cn/public/loadding.gif"
                  />
                )}
                {item?.msgQueen?.map((queen: any, index: any) => {
                  return (
                    <React.Fragment key={index}>
                      {queen.event === SseResponseEventEnum.flowNodeStatus && (
                        <ImageLoading event={queen.event} />
                      )}
                      {queen.event === SseResponseEventEnum.answer ||
                      queen.event === SseResponseEventEnum.error ? (
                        <Markdown
                          showAnimation={
                            sessionStatu === SessionStatuTypes.pending && isLast
                            // &&
                            // isLast &&
                            // !renderItem.out_finished &&
                            // renderItem.stop !== 1
                          }
                          content={queen.value}
                        />
                      ) : queen.event !== SseResponseEventEnum.flowNodeStatus &&
                        queen.event !== SseResponseEventEnum.info ? (
                        <ToolContent content={queen} />
                      ) : null}
                      {queen.event === SseResponseEventEnum.info &&
                      queen?.referenceDocs?.length ? (
                        <div>
                          <div className="leading-7">引用来源：</div>
                          {queen?.referenceDocs?.map(
                            (ele: any, ind: number) => {
                              let refDocInfo = {
                                page_contents: ele.page_contents,
                                reference_index: ele.reference_index,
                              }
                              let docName = `${ele.metadata.document_name}.
              ${ele.metadata.data_type}`
                              return (
                                <div
                                  key={ind}
                                  className="cursor-pointer leading-6"
                                >
                                  {ind + 1}，{ele.metadata.document_name}.
                                  {ele.metadata.data_type}
                                  &ensp;
                                  {refDocInfo.reference_index?.map(
                                    (numDoc: any, count: number) => {
                                      return (
                                        <span
                                          key={count}
                                          className=" text-sky-400"
                                          onClick={() => {
                                            handleDoc(
                                              refDocInfo.reference_index,
                                              refDocInfo.page_contents,
                                              docName,
                                              count,
                                            )
                                          }}
                                        >
                                          [{numDoc}]
                                        </span>
                                      )
                                    },
                                  )}
                                </div>
                              )
                            },
                          )}
                        </div>
                      ) : null}
                    </React.Fragment>
                  )
                })}
                {isLoadingQuestion && isLast && (
                  <div
                    // className={styles.related}
                    style={{ display: 'inline-block' }}
                  >
                    <img
                      className="w-5 h-5"
                      src="https://zdtc-cdn.wair.ac.cn/public/loadding.gif"
                    />
                  </div>
                )}
              </div>
              {/* {item.value && <Markdown content={item.value} />} */}
            </div>
          )}
        </div>
      </div>
      <Modal
        open={visible}
        width={800}
        onCancel={handleCancel}
        destroyOnClose
        // title="引用来源："
        title={
          <div className={styles.modalTitle}>
            <div>引用来源：{docName}</div>
            {pageContents.length > 1 ? (
              <div className={styles.numberArr}>
                <span className={styles.arrow}>
                  <LeftOutlined
                    onClick={() => {
                      changeRefPage(-1)
                    }}
                  />
                </span>
                {pageContents?.map((numDoc: any, index: number) => {
                  return (
                    <span
                      className={`${styles.number} ${
                        index === curPage ? 'text-sky-400' : ''
                      }`}
                      onClick={() => {
                        changeRefPage(0, String(index))
                      }}
                      key={index}
                    >
                      [{curRefIndex[index]}]
                    </span>
                  )
                })}
                <span className={styles.arrow}>
                  <RightOutlined
                    onClick={() => {
                      changeRefPage(1)
                    }}
                  />
                </span>
              </div>
            ) : null}
          </div>
        }
        footer={null}
        className={styles.quoteModal}
      >
        <div
          className={`max-h-[500px] overflow-y-auto ${styles.quoteCollapse}`}
        >
          <Markdown
            content={pageContents[curPage]}
            className={styles.docMarkDown}
          />

          {/* <div className="docMarkDown" style={{ whiteSpace: 'pre-wrap' }}>
            {pageContents[curPage]}
          </div> */}
        </div>
      </Modal>
    </div>
  )
}
